enum PageUrl {
  HOME = '/',
  WORKFLOW_CHECKOUT = '/checkout',
  TERMS_AND_CONDITIONS = '/terms-and-conditions',
  FAQ = '/faq'
}

export default PageUrl;
